import { AES, enc, SHA256 } from 'crypto-js';
import { Asymmetric } from './Asymmetric';

export interface IEncryptAsymmetricReturn {
  cipher: string;
  nonce: string;
  fallbackValue?: any;
}

export interface IDecryptAsymmetricParams {
  cipher: string,
  privateKey: string,
  publicKey: string,
  fallbackValue?: any;
}

export interface IEncryptAsymmetricParams {
  string: string;
  publicKey: string;
  fallbackValue?: any;
}

interface IEncryptSymmetricParams {
  string: string;
  key: string;
  fallbackValue?: any;
}

interface IDecryptSymmetricParams {
  cipher: string;
  key: string;
  fallbackValue?: any;
}

export const encryptAsymmetric = (params: IEncryptAsymmetricParams): Promise<string> => {
  const {
    string,
    publicKey,
    fallbackValue,
  } = params;
  try {
    if (typeof string !== 'string' || !string.length) {
      if (fallbackValue !== undefined) {
        return fallbackValue;
      }
      throw new Error('encryptAsymmetric, empty string input');
    }
    return Asymmetric
      .fromSerialized({ publicKey })
      .encrypt(string);
  } catch (e) {
    if (fallbackValue !== undefined) {
      return fallbackValue;
    }
    throw e;
  }
};

export const decryptAsymmetric = (params: IDecryptAsymmetricParams): Promise<string> => {
  const {
    cipher,
    privateKey,
    publicKey,
    fallbackValue,
  } = params;
  try {
    if (typeof cipher !== 'string' || !cipher.length) {
      if (fallbackValue !== undefined) {
        return fallbackValue;
      }
      throw new Error('decryptAsymmetric, empty cipher input');
    }
    return Asymmetric.fromSerialized({
      privateKey,
      publicKey,
    })
      .decrypt(cipher);
  } catch (e) {
    if (fallbackValue !== undefined) {
      return fallbackValue;
    }
    throw e;
  }
};

export const encryptSymmetric = ({
  string,
  key,
  fallbackValue,
}: IEncryptSymmetricParams): string => {
  try {
    if (typeof string !== 'string' || !string.length) {
      if (fallbackValue !== undefined) {
        return fallbackValue;
      }
      throw new Error('encryptSymmetric, empty string input');
    }
    return AES
      .encrypt(string, key)
      .toString();
  } catch (e) {
    if (fallbackValue !== undefined) {
      return fallbackValue;
    }
    throw e;
  }
};

export const decryptSymmetric = ({
  cipher,
  key,
  fallbackValue,
}: IDecryptSymmetricParams): string => {
  try {
    if (typeof cipher !== 'string' || !cipher.length) {
      if (fallbackValue !== undefined) {
        return fallbackValue;
      }
      throw new Error('decryptSymmetric, empty cipher input');
    }
    const bytes = AES.decrypt(cipher, key);
    return bytes.toString(enc.Utf8);
  } catch (e) {
    if (fallbackValue !== undefined) {
      return fallbackValue;
    }
    throw e;
  }
};

export const createSHA256SaltedHash = (string: string, salt: string) => SHA256(string + salt)
  .toString(enc.Hex);

export {
  generateSalt, deriveKey, derivePasswordKey,
} from './keyDerivation';

export { md5Hash } from './hashes';
